import { DefaultTheme } from 'styled-components'
import colors_ from 'core/theme/colors'
import { getThemeColor } from 'core/theme_new/colors'

const colors = {
    ...colors_,
    tealDarkest: '#167387',
    tealDarker: '#2594AC',
    tealDark: '#2EB1CE',
    teal: '#47CFED',
    tealLight: '#6BDAF2',
    tealLighter: '#92E4F6',
    tealLightest: '#BFF4FF',
    pinkDark: '#9D0E66',
    pink: '#ef4e88',
    pinkLight: '#FE79B4',
    pinkLighter: '#FFADD2',
    pinkLightest: '#FFCEE4',
    redDark: '#c3494e',
    red: '#FE6A6A',
    redLight: '#FF8686',
    redLighter: '#FFA3A3',
    redLightest: '#FFC2C2',
    blue: '#3633B7',
    blueLight: '#775CE0',
    blueLighter: '#B0AEEF',
    blueLightest: '#D0CFF9',
    purpleDarkest: '#3E1A4D',
    purpleDarker: '#532566',
    purpleDark: '#6D3385',
    purple: '#8D4CA8',
    purpleLight: '#A964C6',
    purpleLighter: '#C185DA',
    purpleLightest: '#D5A7E8',
    purpleLightester: '#EFDCF8',
    green: '#4BC77D',
    greenLight: '#73D49A',
    greenLighter: '#B6F4CF',
    white: '#FFF6E6',
    yellowLight: '#FFF1C0',
    yellow: '#FFE589',
    greyDarker: '#303435',
    greyDark: '#4E5557',
    grey: '#8B8085',
    greyLight: '#BBB2B6',
    greyLighter: '#DED1D7',
    greyLightest: '#EADEE3',

    kakiDark: '#9ca033',
    kaki: '#CCD133',
    electricBlueLight: '#AEF0FF',
    electricBlue: '#38D6FE',
    electricBlueDark: '#21B1D6',
    electricBlueDarker: '#129DC0',
    electricBlueDarkerer: '#07657D',
    electricBlueDarkest: '#224149',
    electricBlueDarkestest: '#0C2B33',
    electricBlueMuted1: '#314448',
    orangeLight: '#FFBA53',
    orange: '#EC9C23',
    orangeDark: '#D98C18',
    orangeDarker: '#BE780F',
    yellowDark: '#ECCB55',
    yellowDarker: '#D2AA19',

    blueGreenLightest: '#C9FFF2',
    blueGreenLighter: '#A1FFE8',
    blueGreenLight: '#75FBDA',
    blueGreen: '#51F2CB',
    blueGreenDark: '#34E1B7',
    blueGreenDarker: '#23D2A8',
    blueGreenDarkest: '#16AF8A',

    lilacLighter: '#E9DCFF',
    lilacLight: '#DCC7FF',
    lilac: '#BD95FF',
    lilacDark: '#B896EF',
    lilacDarker: '#A17AE0',
    lilacDarkerer: '#815CBF',
    lilacDarkest: '#6A499D',
    lilacDarkest2: '#604B81',
    lilacDarkest3: '#503E6A',
    lilacDarkest4: '#3A3444'
}

const velocity = [
    '#173E48',
    '#064151',
    '#074B5C',
    '#07657D',
    '#0F7C98',
    '#129DC0',
    '#21B1D6',
    '#38D6FE',
    '#67E0FF',
    '#AEEFFF',
    '#D3F6FF',
    '#E5FFFA',
    '#BCFFF3',
    '#9FFFEE',
    '#9FFFBA',
    '#61F99E',
    '#37EF80',
    '#15ED6B',
    '#06DF0E',
    '#0ECC16',
    '#0AB411',
    '#089F0E',
    '#068A0B'
]

// const velocity = [
//     '#1734BF',
//     '#3633B7',
//     '#5432AE',
//     '#7331A6',
//     '#91319D',
//     '#B03095',
//     '#CE2F8C',
//     '#ED2E84',
//     '#FB549F',
//     '#FE79B4',
//     '#FFA6CE',
//     '#FFCEE4',
//     '#FFE3F0',
//     '#FFEFFF'
// ]

const distinct = [
    colors.indigo,
    colors.teal,
    colors.pink,
    colors.red,
    colors.green,
    colors.yellow,
    colors.aqua,
    colors.orange,
    colors.olive,
    colors.skyblue,
    colors.purple,
    colors.blueLighter,
    colors.greyTeal,
    colors.kaki
]

export const surveyColorTheme = {
    lightOnDark: {
        primary: { default: '#ff8196', darker: '#c0384f' },
        background: { default: '#231F20', alt: '#393234', alt2: '#55474a' },
        text: { default: '#f8e6e9' },
        experience: {
            heard: 'rgb(166, 183, 245)',
            used: 'rgb(32, 111, 175)',
            never_heard: 'rgb(139, 128, 131)'
        },
        sentiment: {
            positive: '#5ce58cff',
            negative: 'rgb(232, 64, 103)',
            neutral: '#8b8b80ff'
        },
        velocity: [
            'hsl(350, 61%, 20%)',
            'hsl(350, 61%, 25%)',
            'hsl(350, 61%, 30%)',
            'hsl(350, 61%, 35%)',
            'hsl(350, 61%, 40%)',
            'hsl(350, 61%, 45%)',
            'hsl(350, 61%, 50%)',
            'hsl(350, 61%, 55%)',
            'hsl(350, 61%, 60%)',
            'hsl(350, 61%, 65%)',
            'hsl(350, 61%, 70%)',
            'hsl(350, 61%, 75%)',
            'hsl(350, 61%, 80%)',
            'hsl(350, 61%, 85%)'
        ]
    }
}

const stateOfCSSThemeColors: DefaultTheme['colors'] = {
    background: getThemeColor('background.default'),
    backgroundTrans: 'rgb(39, 35, 37, 0.3)',
    backgroundAlt3: '#27242E',
    backgroundBackground: '#375D70',
    backgroundForeground: colors.navyLighter,
    backgroundAlt: getThemeColor('background.alt'),
    backgroundAltTrans: 'rgba(49, 68, 72, 0.4)',
    backgroundAlt2: getThemeColor('background.alt2'),
    backgroundInverted: '#FFF6E6',
    backgroundInvertedAlt: '#E3D8C4',
    text: getThemeColor('text.default'),
    textAlt: 'rgba(255, 246, 229, 0.5)',
    textInverted: '#272325',
    textHighlight: colors.greenDark,
    link: getThemeColor('primary.default'),
    linkActive: '#5C63E0',
    contrast: '#0bdf67',
    border: '#FFF6E6',
    borderAlt: 'rgba(255, 246, 229, 0.35)',
    heatmap: colors.pinkLight,
    lineChartDefaultColor: '#59DF7F',
    no_answer: [colors.greyLight, colors.greyLightest],
    velocityBarColors: velocity.map((color, i) => ({
        id: `velocityColor${i}`,
        color: velocity[i * 2],
        gradient: [velocity[i * 2 + 1], velocity[i * 2]]
    })),
    // bar colors for variants when using filters and (especially) facets
    barColors: [
        {
            id: 'barColor1',
            color: colors.purple,
            gradient: [colors.purple, colors.purpleLighter]
        },
        {
            id: 'barColor2',
            color: colors.pink,
            gradient: [colors.pinkDark, colors.pink]
        },
        {
            id: 'barColor3',
            color: colors.yellow,
            gradient: [colors.yellowDark, colors.yellow]
        },
        {
            id: 'barColor4',
            color: colors.greyTeal,
            gradient: [colors.greyTeal, colors.greyTealLight]
        },
        {
            id: 'barColor5',
            color: colors.olive,
            gradient: [colors.oliveDark, colors.olive]
        },
        {
            id: 'barColor6',
            color: colors.orange,
            gradient: [colors.orangeDarker, colors.orangeLight]
        },
        {
            id: 'barColor7',
            color: colors.aqua,
            gradient: [colors.aquaDark, colors.aqua]
        },
        {
            id: 'barColor8',
            color: colors.red,
            gradient: [colors.redDark, colors.red]
        },
        {
            id: 'barColor9',
            color: colors.skyblue,
            gradient: [colors.skyblueDark, colors.skyblue]
        },
        {
            id: 'barColor10',
            color: colors.kaki,
            gradient: [colors.kakiDark, colors.kaki]
        },
        {
            id: 'barColor11',
            color: colors.green,
            gradient: [colors.greenDark, colors.green]
        }
    ],
    barColorDefault: {
        id: 'barColorDefault',
        color: colors.blueGreenDark,
        gradient: [colors.blueGreenDark, colors.blueGreenDark]
    },
    barColorNoAnswer: {
        id: 'barColorNoAnswer',
        color: colors.greyLight,
        gradient: [colors.greyLight, colors.greyLightest]
    },
    barChart: {
        primary: getThemeColor('primary.default'),
        primaryGradient: [getThemeColor('primary.darker'), getThemeColor('primary.default')],
        // secondary: colors.yellowLight,
        // secondaryGradient: [colors.yellow, colors.yellowLight],
        secondary: colors.pink,
        secondaryGradient: [colors.pinkDark, colors.pink]
    },
    ranges: {
        tools: {
            would_use: [colors.blueGreenDarker, colors.blueGreenDark],
            would_not_use: [colors.red, colors.redLight],
            interested: [colors.blueGreen, colors.blueGreenLight],
            not_interested: [colors.redLighter, colors.redLightest],
            never_heard: [colors.greyLight, colors.greyLightest]
        },
        toolSections: {
            component_libraries: colors.pinkLight,
            state_management: colors.teal,
            data_loading: colors.green,
            back_end_infrastructure: colors.orange
        },
        sentiment: {
            positive: [getThemeColor('sentiment.positive'), getThemeColor('sentiment.positive')],
            neutral: [getThemeColor('sentiment.neutral'), getThemeColor('sentiment.neutral')],
            negative: [getThemeColor('sentiment.negative'), getThemeColor('sentiment.negative')]
        },
        features: {
            heard: [getThemeColor('experience.heard'), getThemeColor('experience.heard')],
            used: [getThemeColor('experience.used'), getThemeColor('experience.used')],
            never_heard: [
                getThemeColor('experience.never_heard'),
                getThemeColor('experience.never_heard')
            ]
        },
        features_categories: {
            language: colors.purple,
            browser_apis: colors.pink,
            other_features: colors.green
        },
        features_simplified: {
            know_it: '#ACFFC3',
            used_it: '#59DF7F'
        },
        // gender: {
        //     male: [velocity[0], velocity[1]],
        //     female: [velocity[3], velocity[4]],
        //     non_binary: [velocity[6], velocity[7]],
        //     prefer_not_to_say: [velocity[8], velocity[9]],
        //     not_listed: [velocity[10], velocity[11]]
        // },
        // race_ethnicity: {
        //     biracial: velocity[0],
        //     black_african: velocity[1],
        //     east_asian: velocity[2],
        //     hispanic_latin: velocity[3],
        //     middle_eastern: velocity[4],
        //     multiracial: velocity[5],
        //     native_american_islander_australian: velocity[6],
        //     south_asian: velocity[7],
        //     white_european: velocity[8],
        //     south_east_asian: velocity[9],
        //     not_listed: velocity[10]
        // },
        // yearly_salary: {
        //     range_work_for_free: [velocity[0], velocity[1]],
        //     range_0_10: [velocity[2], velocity[3]],
        //     range_10_30: [velocity[4], velocity[5]],
        //     range_30_50: [velocity[6], velocity[7]],
        //     range_50_100: [velocity[8], velocity[9]],
        //     range_100_200: [velocity[10], velocity[11]],
        //     range_more_than_200: [velocity[12], velocity[13]]
        // },
        // years_of_experience: {
        //     range_less_than_1: [velocity[0], velocity[1]],
        //     range_1_2: [velocity[2], velocity[3]],
        //     range_2_5: [velocity[4], velocity[5]],
        //     range_5_10: [velocity[6], velocity[7]],
        //     range_10_20: [velocity[8], velocity[9]],
        //     range_more_than_20: [velocity[10], velocity[11]]
        // },
        // higher_education_degree: {
        //     no_degree: velocity[0],
        //     yes_related: velocity[2],
        //     yes_unrelated: velocity[4]
        // },
        opinions: {
            4: [getThemeColor('velocity[9]'), getThemeColor('velocity[8]')],
            3: [getThemeColor('velocity[7]'), getThemeColor('velocity[6]')],
            2: [getThemeColor('velocity[5]'), getThemeColor('velocity[4]')],
            1: [getThemeColor('velocity[3]'), getThemeColor('velocity[2]')],
            0: [getThemeColor('velocity[1]'), getThemeColor('velocity[0]')]
        },
        bracket: {
            round1: [velocity[2], velocity[3]],
            round2: [velocity[5], velocity[6]],
            round3: [velocity[7], velocity[8]]
        }
    },
    distinct,
    countries: [
        colors.blue,
        colors.blueLight,
        colors.blueLighter,
        colors.pinkLightest,
        colors.pinkLighter,
        colors.pinkLight,
        colors.pink
    ],
    velocity
}

export default stateOfCSSThemeColors
